import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import styles from "./DialogBox.module.css";

const DialogBox = ({ open, onClose, variant, title, children, disabled }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth={variant}
      className={styles.dialog}
    >
      <DialogTitle className={`${styles.borderBottomgrey}`}>
        {title}
      </DialogTitle>
      <DialogContent className={styles.dialogContent}>{children}</DialogContent>
      {disabled && <div className={styles.disabled}></div>}
    </Dialog>
  );
};

export default DialogBox;
